(function() {
    'use strict';

    FileDownloadService.$inject = [
        '$q',
        '$http',
        '$sanitize',
        '$window',
        'growl',
        'v4FileDownloadService',
        'apiUrlPrefix',
        'apiUrlPort'
    ];

    /**
     * @deprecated since version 4.0
     * @param {any} $q The $q service.
     * @param {any} $http The HTTP Backend service.
     * @param {any} $sanitize The $sanitize service.
     * @param {any} $window The Window
     * @param {any} growl The growl service.
     * @param {any} v4FileDownloadService The v4 download service.
     * @param {any} apiUrlPrefix The API Url Prefix.
     * @param {any} apiUrlPort The API Port.
     * @returns {FileDownloadService} The Service.
     */
    function FileDownloadService($q, $http, $sanitize, $window, growl, v4FileDownloadService, apiUrlPrefix, apiUrlPort) {
        var apiServerUrl = apiUrlPrefix + (apiUrlPort ? ':' + apiUrlPort : '');
        var fileApiUrl = apiServerUrl + '/api/files';
        var downloadErrorMessage = 'Your file could not be downloaded.';
        var zipDownloadErrorMessage = 'One or more of your files could not be downloaded. Please refresh your page.';

        var service = {
            generate: getDownloadToken,
            download: downloadFile,
            downloadZip: downloadZip,
            downloadZipV3: downloadZipV3,
            getUrl: getDownloadUrl
        };

        function downloadZip(fileIds) {
            return v4FileDownloadService.getZipDownloadUrls(fileIds)
                .then(function(data) {
                    var urls = data.urls;
                    var isPopupBlocked = false;
                    angular.forEach(urls, function(url){
                        var newWindow = $window.open(url, urls.length > 1 ? '_blank' : '_self');
                        if(!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') 
                        {
                            isPopupBlocked = true;
                        }
                    });

                    if (isPopupBlocked) {
                        var message = `<strong>Incomplete download!</strong><p>Your browser\'s pop-up blocker prevented some files from downloading. Please allow pop-ups for ${$window.location.hostname} and retry the download again.</p>`;
                        message = $sanitize(message);
                        growl.error(message);
                    }
                }, function (reason) {
                    showGrowlMessage(reason);
                });
        }
               
        function downloadZipV3(firmId, fileIds) {
            return getZipDownloadToken(fileIds)
                .then(function (token) {
                    $window.open(fileApiUrl + '/download-zip/' + firmId + '/' + token, '_self');
                }, function (reason) {
                    showGrowlMessage(reason);
                });
        }

        function getDownloadToken(fileId) {
            return $http.post(fileApiUrl + '/generate-download-token/' + fileId)
                .then(function (response) {
                    return response.data;
                });
        }

        function getZipDownloadToken(fileIds) {
            return $http.post(fileApiUrl + '/generate-zip-download-token', fileIds)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    if (response.status === 400) {
                        if (response.data.message.indexOf('size-exceeded:') === 0) {
                            return $q.reject(response.data.message);
                        }
                        if (response.data.message.indexOf('file-missing:') === 0) {
                            return $q.reject(response.data.message);
                        }
                    }
                    return $q.reject('Unknown Error');
                });
        }

        function downloadFile(firmId, fileId) {
            return getDownloadToken(fileId)
                .then(function (token) {
                    $window.open(fileApiUrl + '/' + firmId + '/' + token, '_self');
                }, function () {
                    growl.error(downloadErrorMessage);
                });
        }

        function getDownloadUrl(firmId, fileId) {
            return '/' + firmId + '/downloadFile/' + fileId;
        }

        function showGrowlMessage(reason) {
            var message = zipDownloadErrorMessage;
            if (reason.indexOf('size-exceeded:') === 0) {
                message = reason.substr(14);
            }
            growl.error(message);
        }

        return service;
    }

    module.exports = FileDownloadService;
})();